module.exports = __webpack_public_path__ + "static/media/BoxPlotQ2_4.328e05b5.svg";